// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__10_-L","disabled":"FileBtn_disabled__2jnLH","warn":"FileBtn_warn__11uEl","fade":"FileBtn_fade__126NW"};